import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 1,
  class: "inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold rounded-full bg-primary30 text-white"
}
const _hoisted_3 = {
  key: 0,
  class: "p-2 border-b"
}
const _hoisted_4 = { class: "max-h-60 overflow-auto" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "px-4 py-2 text-sm text-gray-400 italic"
}

import { ref, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectFilter',
  props: {
    isOpen: { type: Boolean },
    label: {},
    icon: {},
    options: {},
    searchable: { type: Boolean },
    dropdownWidth: {},
    multiple: { type: Boolean },
    selectedValue: {},
    alignRight: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["select", "toggle"],
  setup(__props: any, { emit }) {

const props = __props;





const search = ref('')

function toggle() {
  if (props.disabled) return
  search.value = ''
  emit('toggle')
}

function select(option: { value: string }) {
  emit('select', option.value)
}

const selectedCount = computed(() => {
  if (!props.selectedValue) return 0
  if (Array.isArray(props.selectedValue)) return props.selectedValue.length
  return props.selectedValue ? 1 : 0
})

const filteredOptions = computed(() =>
  props.searchable
    ? props.options.filter((opt) => opt.label.toLowerCase().includes(search.value.toLowerCase()))
    : props.options
)

const dropdownClass = computed(() => (props.dropdownWidth ? props.dropdownWidth : 'w-48'))

function isSelected(optionValue: string): boolean {
  if (!props.selectedValue) {
    return false
  }
  if (props.multiple && Array.isArray(props.selectedValue)) {
    return props.selectedValue.includes(optionValue)
  }
  if (!props.multiple && typeof props.selectedValue === 'string') {
    return props.selectedValue === optionValue
  }
  return false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'relative inline-block border rounded-full text-left',
      _ctx.disabled
        ? 'border-neutral-200 cursor-not-allowed opacity-50'
        : 'border-neutral-400 hover:bg-gray-100'
    ])
  }, [
    _createElementVNode("button", {
      onClick: toggle,
      disabled: _ctx.disabled,
      class: "flex items-center gap-2 px-4 py-2 text-sm text-neutral-400 rounded-full disabled:cursor-not-allowed"
    }, [
      (_ctx.icon)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), {
            key: 0,
            class: "w-4 h-4"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(_ctx.label), 1),
      (selectedCount.value > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(selectedCount.value), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
          class: _normalizeClass([
        'absolute z-10 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 min-w-[240px] border border-neutral-200',
        _ctx.alignRight ? 'right-0' : 'left-0',
        dropdownClass.value
      ])
        }, [
          (_ctx.searchable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                  type: "text",
                  placeholder: "Buscar...",
                  class: "w-full px-3 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-primary"
                }, null, 512), [
                  [_vModelText, search.value]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
              return (_openBlock(), _createElementBlock("li", {
                key: option.value,
                onClick: ($event: any) => (select(option)),
                class: _normalizeClass([
            'px-4 py-2 text-sm cursor-pointer',
            isSelected(option.value)
              ? 'bg-gray-100 font-semibold text-primary30'
              : 'text-gray-700 hover:bg-gray-100'
          ])
              }, _toDisplayString(option.label), 11, _hoisted_5))
            }), 128)),
            (filteredOptions.value.length === 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, " Nenhum resultado "))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})